import React, { useEffect, useState, useMemo } from "react";
import RuleFieldMapper from "./RuleFieldMapper";
import { useSelector } from "react-redux";

const Contact2SaleMapper = ({ onChange, ruleMappings, formType = "CONTACT" }) => {
  const [itemFields, setItemFields] = useState<any[]>([]);
  const [errorMessage, setErrorMessage] = useState("");
  const projectFields = useSelector((state: any) =>
    state.projectReducer.getIn(["project", "fields"])
  );

  const validate = () => {
    if (!ruleMappings) return false;
    const saleMappings = ruleMappings["SALE"] || [];
    if (saleMappings.length > 0) {
      if (saleMappings[0].source?.value) {
        return true;
      }
    }
    return false;
  };

  useEffect(() => {
    if (projectFields && projectFields.size > 0) {
      const fields = projectFields
        .filter((item: any) => item.get("formType") == formType)
        .map((item: any) => ({ label: item.get("label"), value: item.get("id") }))
        .toJS();
      setItemFields(fields);
    }
  }, [projectFields?.size, formType]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (validate()) {
      setErrorMessage("");
    } else {
      setErrorMessage("Name must be required.");
    }
  }, [ruleMappings]); // eslint-disable-line react-hooks/exhaustive-deps

  // Memoize sourceOptions to prevent unnecessary re-renders
  const sourceOptions = useMemo(
    () => ({
      SALE: itemFields,
      CONTACT: itemFields,
      COMPANY: itemFields,
    }),
    [itemFields]
  );

  const renderError = () => {
    if (errorMessage != "") {
      return <div className={"text-red-600"}>{errorMessage}</div>;
    }
  };

  return (
    <div className={"space-y-2"}>
      {renderError()}
      <RuleFieldMapper
        showHeaderLabel={false}
        sourcePlaceholder={"Contact field"}
        sourceOptions={sourceOptions}
        fieldMappings={ruleMappings}
        onChangeMappings={onChange}
      />
    </div>
  );
};

export default Contact2SaleMapper;
